<div class="container">
  <app-top-bar [isTalentAvailabilityPage]="true"></app-top-bar>
  <div class="body-container">
    <div class="row">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="panel content header-panel">
        <img alt="Loading..." src="../../assets/images/spinner.gif"/>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !isLoading" class="panel content header-panel">
        <div class="xlarge-margin text-center header-logo">
          <img src="assets/images/talent-availability/subscribed.svg">
        </div>
        <div class="text-center">
          <div class="confirmation-header">
            <h3 translate>talent-availability.error.header</h3>
          </div>

          <p translate>talent-availability.error.body</p>
        </div>
      </div>

      <!-- Unsubscribe Success State -->
      <div *ngIf="!talentAvailable && !error && !isLoading" class="panel content header-panel">
        <div class="xlarge-margin text-center header-logo">
          <img src="assets/images/talent-availability/unsubscribed.svg">
        </div>
        <div class="text-center">
          <div class="confirmation-header">
            <h3 translate>talent-availability.unsubscribe-success.header</h3>
          </div>

          <p translate>talent-availability.unsubscribe-success.no-more-job-notifications</p>
          <div class="bottom-link">
            <a (click)="makeTalentAvailable()"><span
                translate>talent-availability.unsubscribe-success.did-not-meant-to-unsubscribe</span></a>
          </div>
        </div>
      </div>

      <!-- Subscribe Success State -->
      <div *ngIf="talentAvailable && !error && !isLoading" class="panel content header-panel">
        <div class="xlarge-margin text-center header-logo">
          <img src="assets/images/talent-availability/subscribed.svg">
        </div>

        <div class="text-center">
          <div class="confirmation-header">
            <h3 translate>talent-availability.subscribe-success.header</h3>
          </div>
          <p translate>talent-availability.subscribe-success.notifications-back</p>
          <div class="bottom-link">
            <a href="https://my.aquent.com/">
              <span translate>talent-availability.subscribe-success.go-to-myaquent</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
